/**
 * Metadata: Genera el código de descripción que identifica un archivo de logística inversa.
 * Se usa como clave para subir y consultar el archivo en packageRepository.saveFiles.
 */
export const getReversedLogisticFileCode = (receptionId: number): string =>
  `reversed_logistic_file_${receptionId}`;
